import type { AppRouteRecordRaw } from '@/router/types'

export const systemManageRoutes: AppRouteRecordRaw[] = [
  {
    path: 'systemManage',
    name: 'SystemManage',
    component: () => import('@/views/systemManage/index.vue'),
    meta: {
      title: '系统管理',
      icon: 'leixingbumenshanxuanactiveno'
    },
    children: [
      {
        path: 'storeManage',
        name: 'storeManage',
        component: () => import('@/views/systemManage/storeManage/index.vue'),
        meta: {
          title: '门店管理'
        }
      },
      {
        path: 'userManage',
        name: 'UserManage',
        component: () => import('@/views/systemManage/userManage/index.vue'),
        meta: {
          title: '部门与员工'
        }
      },
      {
        path: 'companyManage',
        name: 'CompanyManage',
        component: () => import('@/views/systemManage/companyManage/index.vue'),
        meta: {
          title: '分公司管理'
        }
      },
      {
        path: 'roleManage',
        name: 'RoleManage',
        component: () => import('@/views/systemManage/roleManage/index.vue'),
        meta: {
          title: '角色管理'
        }
      },
      {
        path: 'apiSafety',
        name: 'apiSafeManage',
        component: () => import('@/views/systemManage/apiSafe/index.vue'),
        meta: {
          title: 'api安全'
        }
      },
      {
        path: 'permissionManage',
        name: 'PermissionManage',
        component: () => import('@/views/systemManage/permissionManage/index.vue'),
        meta: {
          title: '权限管理'
        }
      },
      {
        path: 'paramConfig',
        name: 'ParamConfig',
        component: () => import('@/views/systemManage/paramConfig/index.vue'),
        meta: {
          title: '参数配置'
        }
      },
      {
        path: 'personalAccountAuth',
        name: 'personalAccountAuth',
        component: () => import('@/views/systemManage/personalAccountAuth/index.vue'),
        meta: {
          title: '个人账号授权'
        }
      },
      {
        path: 'departmentCategory',
        name: 'departmentCategory',
        component: () => import('@/views/systemManage/departmentCategory/index.vue'),
        meta: {
          title: '部门类别'
        }
      },
      {
        path: 'wechatManage',
        name: 'WechatManage',
        component: () => import('@/views/systemManage/wechatManage/index.vue'),
        meta: {
          title: '微信公众号管理'
        }
      }
    ]
  }
]
